import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { userRequest } from '../utils/requestMethods';
import { Header, ButtonLoading } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import useWriteGuard from '../hooks/useWriteGuard';

const UpdateTransport = ({ history }) => {
  const location = useLocation();
  const addonId = location.pathname.split('/')[2];

  const { school } = useStateContext();
  const { isWriteBlocked, guardWrite } = useWriteGuard();
  const schoolId = school?._id;

  //const [addonDetails, setAddonDetails] = useState({});
  const [addonName, setAddonName] = useState("");
  const [addonPrice, setAddonPrice] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAddon = async () => {
      try {
        const { data } = await userRequest.get(`/transport-addon/${schoolId}/${addonId}`);
        console.log(data);
        //setAddonDetails(data);
        setAddonName(data.add_on_name);
        setAddonPrice(data.add_on_price);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAddon();
  }, [addonId, schoolId]);

  const goBack = () => {
    // Go back to the previous page
    history.goBack();
  };
  
  const submitHandler = async (e) => {
    e.preventDefault();
    if (!guardWrite()) return;
    setLoading(true);

    try {
      await userRequest.put(`/transport-addon/${schoolId}/${addonId}`,
        { 
          add_on_name: addonName, 
          add_on_price: addonPrice,
        });
      //console.log(data);
      setSuccess(true);
      setTimeout(() => {
          setSuccess(false);
          history.push("/transportation");
      }, 3000);
    } catch (error) {
      console.log(error);
      setError(error.response.data);
      setTimeout(() => {
        setError("");
      }, 5000);
    }
    setLoading(false);
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <button
        onClick={goBack}
        className="mb-4 inline-flex items-center gap-2 rounded-full bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        <i className="fad fa-arrow-left"></i>
        Back
      </button>
      <div className="mb-6">
      <Header category="Set Up" title="Update Extra Fee" />
        <p className="text-sm text-slate-500 mt-1">Edit transport add-on details and pricing.</p>
      </div>
      <div className="rounded-2xl border border-slate-200 p-4 md:p-6">
        <form onSubmit={submitHandler} className="space-y-6">
          {error && (
            <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                          {error}
                      </div>
          )}
          {success && (
            <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
              <b>Success!</b> Fee information updated.
                    </div>
          )}

                      <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-200">
              Extra-Fee Name
              <span className="text-slate-400 text-xs ml-1">(Lesson, Excursion, Uniform, etc)</span>
            </label>
            <input
              type="text"
              onChange={(e) => setAddonName(e.target.value)}
              value={addonName}
              className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
              placeholder="Add-on Name"
            />
                      </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-200">Extra-Fee Price</label>
            <input
              type="number"
              onChange={(e) => setAddonPrice(e.target.value)}
              value={addonPrice}
              className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
              placeholder="e.g 20000"
            />
                    </div>
          <div className="flex justify-end">
            {loading ? (
              <ButtonLoading styles="inline-flex justify-center py-3 px-8 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-indigo-600" />
                      ) : (
              <button type="submit" disabled={isWriteBlocked} className="inline-flex justify-center py-3 px-8 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save Fee
              </button>
            )}
              </div>
          </form>
      </div>
    </div>
  );
};
export default UpdateTransport;
